import { Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

const HorizontalTabs = ({ justifyPillsTab, justifyPillsToggle, tabs_data, error_tab }) => {
    return (
        <>
            <Nav className="nav-tabs mb-3 nav nav-tabs error_text">
                {
                    tabs_data &&
                    tabs_data.length > 0 &&
                    tabs_data.map((tab) => {
                        return (
                            <NavItem key={tab.id}>
                                <NavLink
                                    style={{
                                        cursor: tab.disabled ? "not-allowed" : "pointer",
                                        color: tab.id == error_tab && "red",
                                        opacity: tab.disabled ? 0.5 : 1
                                    }}
                                    className={classnames({ active: justifyPillsTab == tab.id, })}
                                    {...(!tab.disabled && {
                                        onClick: () => justifyPillsToggle(tab.id),
                                    })}
                                >
                                    {tab.title}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>

            <TabContent activeTab={justifyPillsTab} className="text-muted mb-3">
                {
                    tabs_data &&
                    tabs_data.length > 0 &&
                    tabs_data.map((tab) => {
                        return (
                            <TabPane tabId={tab.id} id="pill-justified-home-1" key={tab.id}>
                                {tab.component}
                            </TabPane>
                        )
                    })
                }

            </TabContent>
        </>
    );
};

export default HorizontalTabs;
